import React from 'react'
import { cn } from 'components/UI/cn'

interface SlideOutNavButtonProps {
  onClick: () => void
  isActive?: boolean
  'aria-current'?: 'page' | undefined
  'aria-expanded'?: boolean
  children: React.ReactNode
  className?: string
}

/**
 * Reusable navigation button primitive for slide-out panel items.
 * Provides consistent active/inactive styling.
 * Note: Hover is handled via CSS in main.css ([data-slide-out-panel] button:hover)
 * to work around Bootstrap's button resets overriding Tailwind hover classes.
 */
export const SlideOutNavButton: React.FC<SlideOutNavButtonProps> = ({
  onClick,
  isActive = false,
  'aria-current': ariaCurrent,
  'aria-expanded': ariaExpanded,
  children,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      aria-current={ariaCurrent}
      aria-expanded={ariaExpanded}
      data-nav-item
      className={cn(
        'flex items-center w-full h-9 pl-5 pr-1 border-none rounded-lg text-left cursor-pointer transition-colors duration-150',
        isActive ? 'bg-sage-md-dark' : 'bg-transparent',
        className
      )}
    >
      {children}
    </button>
  )
}
